import {
  LIST_ACCOUNTS_REQUEST,
  LIST_ACCOUNTS_SUCCESS,
  LIST_ACCOUNTS_FAIL,
  ADD_ACCOUNT_REQUEST,
  ADD_ACCOUNT_SUCCESS,
  ADD_ACCOUNT_FAIL,
  DEPOSIT_REQUEST,
  DEPOSIT_SUCCESS,
  DEPOSIT_FAIL,
  WITHDRAW_REQUEST,
  WITHDRAW_SUCCESS,
  WITHDRAW_FAIL,
  TRANSFER_REQUEST,
  TRANSFER_SUCCESS,
  TRANSFER_FAIL,
} from '../constants/accountConstants';

export const accountsListReducer = (
  state: { accounts: Account[] } = { accounts: [] },
  action: any
) => {
  switch (action.type) {
    case LIST_ACCOUNTS_REQUEST:
      return { ...state, loading: true };
    case LIST_ACCOUNTS_SUCCESS:
      return { loading: false, accounts: action.payload };
    case LIST_ACCOUNTS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case ADD_ACCOUNT_REQUEST:
      return { ...state, loading: true };
    case ADD_ACCOUNT_SUCCESS:
      // const updatedAccounts = [...state.accounts, action.payload];

      // const newAccounts = updatedAccounts.sort((a, b) => a.id - b.id);

      return { ...state, loading: false, success: true };
    case ADD_ACCOUNT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
    case DEPOSIT_REQUEST:
      return { ...state, loading: true };
    case DEPOSIT_SUCCESS:
      // const updatedId = action.payload.id;

      // const accountToUpdate = state.accounts.find(
      //   (account) => account.id === updatedId
      // );

      // const accountIndex = state.accounts.indexOf(accountToUpdate);

      // state.accounts.splice(accountIndex, 1, action.payload);

      // const sortedAccounts = state.accounts.sort((a, b) => a.id - b.id);

      return { ...state, loading: false, dsuccess: true };
    case DEPOSIT_FAIL:
      return { ...state, loading: false, error: action.payload };
    case WITHDRAW_REQUEST:
      return { ...state, loading: true };
    case WITHDRAW_SUCCESS:
      return { ...state, loading: false, wsuccess: true };
    case WITHDRAW_FAIL:
      return { ...state, loading: false, error: action.payload };
    case TRANSFER_REQUEST:
      return { ...state, loading: true };
    case TRANSFER_SUCCESS:
      return { ...state, loading: false, tsuccess: true };
    case TRANSFER_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
